import { guestApi, storeApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';
import { applyMockBranding, getApiStoreName } from './mockStores';

export const giftSelectionApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Validate a gift code or invitation hash
    validateGiftCode: builder.mutation({
      query: ({ code, codeType }) => ({
        url: guestApi(),
        method: 'POST',
        body: {
          data: codeType === 'invitation' ? { hash: code } : { giftCode: code },
          method: 'checkInvitation'
        },
        suppressGenericErrorToast: true,
      }),
      transformResponse: (response) => response.data,
    }),

    // Fetch store info for branding
    fetchStoreForGift: builder.query({
      query: ({ storeName }) => {
        // Use the real API store name (e.g., 'dn' -> 'DNonlinekurser')
        const apiStoreName = getApiStoreName(storeName);
        return {
          url: storeApi(),
          method: 'POST',
          body: {
            data: {
              hostname: 't-app.s.coursio.com',
              name: apiStoreName,
              skipItems: false,
            },
            method: 'read'
          },
        };
      },
      transformResponse: (response, meta, arg) => {
        const data = response.data;
        // Apply mock branding if this is a mock store (e.g., 'dn')
        return applyMockBranding(arg?.storeName, data);
      },
    }),

    // Fetch available courses for gift selection
    fetchGiftCourses: builder.query({
      query: ({ storeName, giftCode, hash }) => ({
        url: guestApi(),
        method: 'POST',
        body: {
          data: {
            storeName,
            giftCode,
            hash,
          },
          method: 'getGiftCourses'
        },
      }),
      transformResponse: (response) => response.data,
    }),

    // Redeem the selected course
    redeemGiftCourse: builder.mutation({
      query: ({ code, codeType, courseId }) => ({
        url: guestApi(),
        method: 'POST',
        body: {
          data: {
            ...(codeType === 'invitation' ? { hash: code } : { giftCode: code }),
            courseId,
          },
          method: 'acceptInvitation'
        },
      }),
      transformResponse: (response) => response.data,
    }),
  }),
  overrideExisting: false,
});

export const {
  useValidateGiftCodeMutation,
  useFetchStoreForGiftQuery,
  useFetchGiftCoursesQuery,
  useRedeemGiftCourseMutation,
} = giftSelectionApi;
